import { pushDataLayer } from 'utils/data-layer-push'

const anchorAsButtonClick = ($element: HTMLElement): void => {
  const anchorURL = $element instanceof HTMLAnchorElement ? $element.href : ''
  const buttonLabel = $element.textContent || ''

  pushDataLayer('click_button', {
    button_type: 'Button',
    button_text: buttonLabel,
    button_url: anchorURL,
    button_src: window.location.href,
  })
}

const sliderAnchorClick = ($element: HTMLElement): void => {
  const anchorURL = $element instanceof HTMLAnchorElement ? $element.href : ''
  const buttonLabel = $element.textContent || ''

  pushDataLayer('click_button', {
    button_type: 'Slider',
    button_text: buttonLabel,
    button_url: anchorURL,
    button_src: window.location.href,
  })
}

const handleTrackingAction = (event: Event): void => {
  const element = event.currentTarget as HTMLElement
  const trackingID = element.getAttribute('data-track-click')

  switch (trackingID) {
    case 'anchor-button':
      return anchorAsButtonClick(element)
    case 'slider-button':
      return sliderAnchorClick(element)

    default:
      return console.warn('Unhandled tracking event')
  }
}

export function spawnTrackingEventListners(): void {
  const $trackedButtons = document.querySelectorAll<HTMLElement>('[data-track-click]')
  for (const $singleButton of $trackedButtons) {
    $singleButton.addEventListener('click', handleTrackingAction)
  }
}
